import * as types from '../mutation-types'
import features from '@/api/features'
import Vue from 'vue'

const state = {
  features: {},
  featuresLoading: {},
  featuresLoaded: {}
}

const getters = {
  features: (state) => (featureGroupName) => {
    return state.features[featureGroupName] ? state.features[featureGroupName] : {}
  }
}

const actions = {
  getUserFeatures ({ commit, state }, { groupName, nextPageToken }) {
    // ignore if this feature already exists in the store
    if (groupName in state.featuresLoaded || (groupName + nextPageToken) in state.featuresLoading) {
      return new Promise((resolve, reject) => {
        resolve({ hasMore: false })
      })
    }

    commit(types.FEATURES_LOADING, { name: groupName + nextPageToken })
    if (nextPageToken === undefined) {
      this.clearFeatures()
    }
    return new Promise((resolve, reject) => {
      features.get(groupName, nextPageToken).then((response) => {
        const features = response.data.result.platformFeatures
        const hasMore = response.data.result.hasMore
        const nextPageToken = response.data.result.nextPageToken
        if (features && features.length > 0) {
          commit(types.ADD_FEATURES, { name: groupName, features: features, hasMore: hasMore })
        }
        if (!hasMore) {
          commit(types.FEATURES_LOADED, { name: groupName })
        }
        resolve({ hasMore, nextPageToken })
      }, (error) => {
        reject(error)
      })
    })
  },
  clearFeatures ({ commit }) {
    commit(types.CLEAR_FEATURES)
  }
}

const mutations = {
  [types.ADD_FEATURES] (state, { name, features, hasMore }) {
    if (state.features === null || (state.features && !state.features[name])) {
      Vue.set(state.features, name, features)
    } else {
      state.features[name].push(...features)
    }
  },
  [types.FEATURES_LOADING] (state, { name }) {
    state.featuresLoading[name] = true
  },
  [types.FEATURES_LOADED] (state, { name }) {
    state.featuresLoaded[name] = true
  },
  [types.CLEAR_FEATURES] (state) {
    state.features = {}
    state.featuresLoaded = {}
  },
  [types.RESET_ON_LOGOUT] (state) {
    state.features = {}
    state.featuresLoaded = {}
    state.featuresLoading = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
